import EchartMap from './echart-map';
export default EchartMap;
